import { TranslateService } from '@ngx-translate/core';
import { PageConfigService } from 'src/app/page-config.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sidenav-offline-content',
  templateUrl: './sidenav-content.component.html',
  styleUrls: ['./sidenav-content.component.scss']
})
export class SidenavContentComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();

  CloseAction() {
    this.close.emit(true);
  }
  constructor(public translate: TranslateService, private PageConfigService: PageConfigService) {
    this.PageConfigService.config.subscribe((x) =>{this.urlRegister = x.sub_link, this.urlInform = x.inform_link, this.buton_celm = x.button_clem_guest})


      // translate
      translate.addLangs(['fr', 'en', 'es']);
      translate.setDefaultLang('fr');
  
      const browserLang = translate.getBrowserLang();
      translate.use(browserLang.match(/fr|en|es|ca/) ? browserLang : 'fr');

      this.site = this.getSite();
  }

  site: string;

  locales = [
    { label: '🇫🇷', value: 'fr' },
    { label: '🇺🇸', value: 'en' },
    { label: '🇪🇸', value: 'es' },
    { label: 'ca', value: 'ca' },
  ];

  urlRegister: any
  urlInform: any
  buton_celm: any
  
  ngOnInit() {
  }


  getSite(): string {
  const host = location.host;

  switch (host) {
    case 'mam.clem.mobi':
    case 'www.mam.clem.mobi':
      return 'mam';

    // case 'localhost:4200':
    // case `devghiles.clem.mobi` : 
    case 'remiautopartage.clem.mobi':
    case 'www.remiautopartage.clem.mobi':
      return 'remi';

    default:
      return 'default';
  }
}
  

}
